import React from 'react'
import { Button } from 'antd';

import lightBoltIcon from '../../../assets/logo/light-bolt.png'
import './styles.scss'

export default ({s3Acceleration, onChange }) => {
  //let text = s3Acceleration ? 'Accelerator Enabled' : 'Boost your files upload with S3 Accelerator!'
  return (
    <div className={"indicator s3-accelerator columnWrap center-child " + (s3Acceleration ? 'selected' : '')}>
      {s3Acceleration ? <img src={lightBoltIcon} /> : null}
      <span>Boost your files upload with S3 Accelerator!</span>
      <Button onClick={onChange}>
        {s3Acceleration ? <img src={lightBoltIcon} /> : null}
        <span>{s3Acceleration ? 'Accelerator Enabled' : 'Use S3 Accelerator'}</span>
      </Button>
    </div>
  )
}
